{
  "version": 1,
  "asset_id": "2b73a345-a541-4028-bc6b-a69d0fada37a",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/2b73a345-a541-4028-bc6b-a69d0fada37a/sofort.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/2b73a345-a541-4028-bc6b-a69d0fada37a/sofort.svg",
  "original_filename": "sofort.svg",
  "size": 2110,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:29Z"
}
